import React from 'react';

export const DoubleArrow: React.FC = () => {
	return (
		<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				opacity="0.4"
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M19.3706 5.03026C19.7424 5.44077 19.7089 6.07306 19.2958 6.44252L12.5877 12.4425C12.2051 12.7848 11.6242 12.7848 11.2415 12.4425L4.53344 6.44252C4.12038 6.07306 4.08689 5.44077 4.45864 5.03026C4.8304 4.61975 5.46662 4.58647 5.87967 4.95593L11.9146 10.3539L17.9496 4.95593C18.3626 4.58647 18.9988 4.61975 19.3706 5.03026Z"
				fill="#AAADB8"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M19.3706 13.0303C19.7424 13.4408 19.7089 14.0731 19.2958 14.4425L12.5877 20.4425C12.2051 20.7848 11.6242 20.7848 11.2415 20.4425L4.53343 14.4425C4.12038 14.0731 4.08689 13.4408 4.45864 13.0303C4.8304 12.6198 5.46661 12.5865 5.87967 12.9559L11.9146 18.3539L17.9496 12.9559C18.3626 12.5865 18.9988 12.6198 19.3706 13.0303Z"
				fill="#AAADB8"
			/>
		</svg>
	);
};
